export default {"src":"/_next/static/media/store.141a87f8.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};